import util from '../util'

let controller = 'EnvioTED'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post']))
